// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBanner_container__3RLE9","icon":"ErrorBanner_icon__CkQEn","info":"ErrorBanner_info__2F96e"};